import { CommApiInstance } from "Utils/CommApiInstance";




const MembGameSvcMnyApi = async (
    GameSvcCd:string
) => {
    return await CommApiInstance.post("memb/gamemny/"+GameSvcCd,{
        apiBody:{
        },
    })
    .then((Resp) => Resp.data);
}
export default MembGameSvcMnyApi;